import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { Styles } from './styles';
import { currency } from '../../../utils/functions';
import { formatDate } from '../../../utils/format-date';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import { ITreatment } from '../../../interfaces';

interface IProps {
  data: ITreatment[];
  period: string;
}

export const TreatmentsListReport: React.FC<IProps> = ({ data, period }) => {
  const { company } = useCompany();

  return (
    <RViewer>
      <RPage size="A4">
        <View style={Styles.container}>
          <RHeader company={company} />
          <View style={Styles.header}>
            <Text style={Styles.title}>Relatório de Tratamentos</Text>
            <Text style={Styles.subtitle}>Período: {period}</Text>
          </View>

          <View style={Styles.table}>
            <View style={Styles.tableRow}>
              <View style={{ ...Styles.tableColHeader, width: '15%' }}>
                <Text style={Styles.tableCellHeader}>Data</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '30%' }}>
                <Text style={Styles.tableCellHeader}>Cliente</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '25%' }}>
                <Text style={Styles.tableCellHeader}>Profissional</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '15%' }}>
                <Text style={Styles.tableCellHeader}>Status</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '15%' }}>
                <Text style={Styles.tableCellHeader}>Valor</Text>
              </View>
            </View>

            {data.map((item, index) => (
              <View key={index} style={Styles.tableRow}>
                <View style={{ ...Styles.tableCol, width: '15%' }}>
                  <Text style={Styles.tableCell}>
                    {formatDate(new Date(item.created_at).toLocaleString())}
                  </Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '30%' }}>
                  <Text style={Styles.tableCell}>{item.client_name}</Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '25%' }}>
                  <Text style={Styles.tableCell}>
                    {item.professional_name || '-'}
                  </Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '15%' }}>
                  <Text style={Styles.tableCell}>
                    {item.approval ? 'Aprovado' : 'Pendente'}
                  </Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '15%' }}>
                  <Text style={Styles.tableCell}>{currency(item.total)}</Text>
                </View>
              </View>
            ))}
          </View>

          <Text
            style={Styles.footer}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </View>
      </RPage>
    </RViewer>
  );
};
